import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchRestaurantSearchResults,
  clearRestaurantSearchResults,
} from "../slice/googlePlacesSlice";
import GooglePlace from "./GooglePlace";
import Spinner from "../util/Spinner";
import useLoginCheck from "../util/useLoginCheck";

const AddRestaurantToList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sid: listSid } = useParams();

  const [query, setQuery] = useState("");
  const [hasClickedSearch, setHasClickedSearch] = useState(false);

  const { results, isLoading } = useSelector((state) => state.googlePlaces);

  useLoginCheck();

  const goBack = () => navigate(-1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(clearRestaurantSearchResults());
    setHasClickedSearch(true);
    dispatch(fetchRestaurantSearchResults(query));
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      <form
        onSubmit={handleSubmit}
        className="flex flex-col sm:flex-row gap-2 mb-4"
      >
        <input
          type="text"
          className="flex-1 border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600"
          placeholder="Restaurant name or cuisine"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          required
        />
        <div className="flex gap-2 justify-end">
          <button type="button" onClick={goBack} className="btn-secondary">
            Cancel
          </button>
          <button
            type="submit"
            disabled={query.trim() === "" || isLoading}
            className="btn-primary"
          >
            {isLoading ? "Searching..." : "Search"}
          </button>
        </div>
      </form>
      {hasClickedSearch && (
        <div>
          {isLoading ? (
            <Spinner />
          ) : (
            <div className="space-y-3">
              {results?.results?.length > 0 ? (
                results.results.map((place, index) => (
                  <GooglePlace
                    key={place.googlePlaceId ?? index}
                    place={place}
                    listSid={listSid}
                  />
                ))
              ) : (
                <div className="text-stone-500">No restaurants found</div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AddRestaurantToList;
